import React from 'react';
import { useSelector } from 'react-redux';
import { getIsSessionExpired, type SessionExpiredStateTree } from '@makemydeal/dr-sales-checkin-store';

import { SessionExpiredOverlayView } from './SessionExpiredOverlayView';

export const SessionExpiredOverlay = (): React.JSX.Element | null => {
    const isSessionExpired = useSelector((state: SessionExpiredStateTree) => getIsSessionExpired(state));

    if (!isSessionExpired) return null;

    return <SessionExpiredOverlayView />;
};
